var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad"},_vm._l((_vm.adList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('a',{attrs:{"href":item.linkUrl,"target":"_blank"}},[_c('img',{attrs:{"src":item.imgUrl}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }